// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__4au2a","box":"styles_box__oG7Mk","description":"styles_description__WUIvc"};